import { useEffect, useRef } from "react";
//#region src/presentation/hooks/use-first-render.ts
var useFirstRender = () => {
	const firstRender = useRef(true);
	useEffect(() => {
		firstRender.current = false;
	}, []);
	return firstRender.current;
};
//#endregion
export { useFirstRender };

//# sourceMappingURL=use-first-render.js.map